import { useMutation, useQueryClient } from "@tanstack/react-query";
import InterventiService from "../services/InterventiService";

export default function useEliminaInterventi() {
  const queryClient = useQueryClient();
  const { isLoading, mutate, error } = useMutation({
    mutationFn: async (ids: number[]) => {
      await InterventiService.eliminaInterventi(ids);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries(["interventi"]);
    },
  });
  return {
    isLoading,
    eliminaInterventi: mutate,
    error,
  };
}
